// src/firebase.ts
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const functionsClient = getFunctions(app);



// import { initializeApp } from 'firebase/app';
// import { getAuth } from 'firebase/auth';
// import { getFirestore } from 'firebase/firestore';


// const firebaseConfig = {
//   apiKey: "AIzaSyAVZ01l4GX_9hrRV5vokb2RGRifJ5nZSYk",
//   authDomain: "onehub-465923.firebaseapp.com",
//   databaseURL: "https://onehub-465923-default-rtdb.firebaseio.com",
//   projectId: "onehub-465923",
//   storageBucket: "onehub-465923.firebasestorage.app",
//   messagingSenderId: "812276002980",
//   appId: "1:812276002980:web:e6d50e71b24be515b77631",
//   measurementId: "G-5LM7NFRWNB"
// };

// // Inicializar Firebase
// const app = initializeApp(firebaseConfig);

// // Exportar servicios que necesitarás
// export const auth = getAuth(app);
// export const db = getFirestore(app);
// export default app;

